export const defaultMaxResults = 50;

export enum filterId {
  query = 'query',
  userMember = 'userMember',
  externalMemberName = 'externalMemberName',
  externalMemberEmail = 'externalMemberEmail'
}
